/* Release 6 home (australia_home_release6_spec.md). Deferred, home only.
   1. Entrance: fade up 12 px, 400 ms, ease out, once per section when its top
      passes 85 percent of the window height (CSS in au-r6-home.css). Release
      6.6.1: a rootMargin instead of a 15 percent threshold, so a section taller
      than the window still appears. Off under prefers-reduced-motion.
   2. Add to bag from the panels through the live cart behaviour
      (window.AUPurchase in assets/au-purchase.js) without the redirect to the
      cart: "Adicionando", then "Na sacola" for 2 seconds, the header bag count
      updates from au-purchase's theme:cart:change event; on failure the
      button says "Não deu para adicionar. Tente de novo." When the result is
      unknown (the add may have gone through) au-purchase keeps its own
      "confira sua sacola" state and the operation open; no retry here.
      Without au-purchase the form posts to the cart as usual.
   3. Home events (spec section 14) through window.AVAnalytics.custom, which
      checks consent and the event list. No personal data. */
(() => {
  if (window.AUR6Home) return;
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track = (event, payload = {}) => { try { window.AVAnalytics?.custom?.(event, payload); } catch (_) { /* analytics are optional */ } };
  const json = (node) => { try { return JSON.parse(node?.textContent || '{}'); } catch (_) { return {}; } };

  /* 1. Entrance */
  const reveal = [...document.querySelectorAll('[data-au-r6-reveal]')];
  if (!reduce && 'IntersectionObserver' in window && reveal.length) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    for (const section of reveal) {
      if (section.getBoundingClientRect().top < window.innerHeight * 0.85) section.classList.add('is-in');
      else observer.observe(section);
    }
    root.classList.add('au-r6-motion');
  }

  /* 2. Add to bag */
  const labelsFor = (form) => json(form.closest('[data-au-purchase]')?.querySelector('[data-au-purchase-config]')).labels || {};
  const panelData = (node) => {
    const panel = node.closest('[data-au-r6-panel]');
    return { product_handle: panel?.dataset.productHandle, position: Number(panel?.dataset.position) || undefined };
  };
  // au-purchase keeps a confirmed form locked; after the 2 s "Na sacola" a fresh
  // copy of the form takes its place so the panel can add again.
  const renew = (form) => {
    if (!form.isConnected) return;
    const labels = labelsFor(form);
    const fresh = form.cloneNode(true);
    for (const name of ['data-au-purchase-state', 'aria-busy', 'data-au-purchase-form']) fresh.removeAttribute(name);
    const button = fresh.querySelector('[data-au-r6-add]');
    if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    const label = fresh.querySelector('[data-au-purchase-label]');
    if (label && labels.add) label.textContent = labels.add;
    form.replaceWith(fresh);
  };
  const fail = (form) => {
    const labels = labelsFor(form);
    const label = form.querySelector('[data-au-purchase-label]');
    const status = form.closest('[data-au-purchase]')?.querySelector('[data-au-purchase-status]');
    if (labels.error) {
      if (label) label.textContent = labels.error;
      if (status) status.textContent = labels.error;
    }
    window.setTimeout(() => renew(form), 4000);
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-au-r6-add]');
    if (!button || !window.AUPurchase?.add) return;
    const form = button.form;
    if (!form || button.disabled) return;
    event.preventDefault();
    let result;
    try { result = await window.AUPurchase.add(form, { navigate: false }); } catch (_) { result = { status: 'error' }; }
    if (!result || result.status === 'blocked') return;
    const data = panelData(form);
    const kit = Boolean(form.closest('[data-au-r615-kit]'));
    if (result.status === 'confirmed') {
      const variant = (json(form.closest('[data-au-purchase]')?.querySelector('[data-au-purchase-config]')).variants || [])[0];
      if (!kit) track('home_panel_add_to_cart', { ...data, price: variant ? variant.price / 100 : undefined });
      window.setTimeout(() => renew(form), 2000);
    } else if (result.status !== 'unknown') {
      if (!kit) track('home_panel_add_error', data);
      fail(form);
    }
  });

  /* 3. Events: clicks marked data-au-r6-event, and panel views (50 percent for 1 s, once) */
  document.addEventListener('click', (event) => {
    const node = event.target.closest('[data-au-r6-event]');
    if (!node) return;
    const payload = {};
    if (node.dataset.auR6Target) payload.target = node.dataset.auR6Target;
    if (node.dataset.collectionHandle) payload.collection_handle = node.dataset.collectionHandle;
    if (node.dataset.position) payload.position = Number(node.dataset.position);
    if (node.dataset.kit) payload.kit = node.dataset.kit;
    if (node.dataset.action) payload.action = node.dataset.action;
    track(node.dataset.auR6Event, payload);
  });
  const panels = [...document.querySelectorAll('[data-au-r6-panel]')];
  if ('IntersectionObserver' in window && panels.length) {
    const timers = new Map();
    const viewer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const panel = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (timers.has(panel)) continue;
          timers.set(panel, window.setTimeout(() => {
            viewer.unobserve(panel);
            track('home_panel_view', panelData(panel));
          }, 1000));
        } else if (timers.has(panel)) {
          window.clearTimeout(timers.get(panel));
          timers.delete(panel);
        }
      }
    }, { threshold: [0, 0.5] });
    panels.forEach((panel) => viewer.observe(panel));
  }

  window.AUR6Home = Object.freeze({ version: '1.0' });
})();
